import VueJsonPretty from 'vue-json-pretty'
import {defineNuxtPlugin} from 'nuxt/app'

export default defineNuxtPlugin((nuxtApp: any) => {
    nuxtApp.vueApp.component("vue-json-pretty", VueJsonPretty)
})


